import{filterSupportedOptions as n}from"./filterSupportedOptions.mjs";const o=o=>!!o.fundingConfig&&n(o.fundingConfig.options).length>=1;export{o as isFundingEnabled};
